module.exports = __webpack_public_path__ + "static/media/bg.1acfd0eb.webm";